import { useAppSelector } from 'app/hooks';
import { useMemo } from 'react';
import {
  groupSpaceTypeItems,
  hasAnySpaceTypeItems
} from 'utils/space-type-groups';
import { getAssignedImageForLevel, isLevelConditioned } from 'utils/structure';
import { UseSpaceTypeGroupsResult } from './use-space-type-groups-types';

export function useSpaceTypeGroups(
  searchText: string
): UseSpaceTypeGroupsResult {
  const { items } = useAppSelector((state) => state.data);
  const { activeLevelIndex } = useAppSelector((state) => state.ui);
  const { structure, structureAttachments, structureImageAssignments } =
    useAppSelector((state) => state.structure);
  const { spacesLoading } = useAppSelector((state) => state.ai);

  const currentLevel = structure[activeLevelIndex];
  const isConditioned = isLevelConditioned(currentLevel ?? null);
  const assignedImage = currentLevel
    ? getAssignedImageForLevel(
        currentLevel.uniqueId,
        structureImageAssignments,
        structureAttachments
      )
    : null;
  const suggestedSpaces = currentLevel?.suggestedSpaces;
  const hasSuggestions =
    !!assignedImage && !!suggestedSpaces && suggestedSpaces.length > 0;
  const isAnalyzingSuggestions =
    !!assignedImage && !hasSuggestions && spacesLoading;

  const groups = useMemo(
    () =>
      groupSpaceTypeItems({
        items,
        isConditioned,
        suggestedSpaces,
        hasSuggestions,
        searchText
      }),
    [items, isConditioned, suggestedSpaces, hasSuggestions, searchText]
  );

  return {
    ...groups,
    isAnalyzingSuggestions,
    isEmpty: !hasAnySpaceTypeItems(groups)
  };
}
